export default {
  dataIterator: {
    rowsPerPageText: 'Itens por página:',
    rowsPerPageAll: 'Todos',
    pageText: '{0}-{1} de {2}',
    noResultsText: 'Nenhum registro encontrado com estes filtros',
    nextPage: 'Próxima página',
    prevPage: 'Página anterior',
  },
  dataTable: {
    rowsPerPageText: 'Linhas por página:',
  },
  noDataText: 'Nenhum dado disponível',
};
